import React, { Component } from 'react'
import PropTypes from 'prop-types'
import NoOrders from "../../../home/components/orders/NoOrders"
import { Spin, Tooltip } from "antd"
import BatchList from "./BatchList"

class BatchTable extends Component {
    _renderTableContent = () => {
        const { orders, loading, reloadItems, statusBatch, batch, dataType } = this.props

        if (orders.length === 0) {
            return <NoOrders loading={loading} />
        }

        return <BatchList orders={orders} reloadItems={reloadItems} statusBatch={statusBatch} batch={batch} dataType={dataType} />
    }

    render() {
        const tableContent = this._renderTableContent()
        const { batch, loading, handleSort, filters, dataType } = this.props
        const { statistic_data = {} } = Object.assign({}, batch)
        const { orderBy, orderSortType } = { ...filters }

        const hasSKUTheu = Object.values(dataType).some(item => {
            return item.production_process?.name?.toLowerCase() === 'thêu';
        })

        const sortTitle = (field) => {
            if (orderBy === field) {
                if (orderSortType === 'asc') return <span><i className="fa fa-sort-amount-desc" aria-hidden="true"></i>Sort descending</span>
                if (orderSortType === 'desc') return <span><i className="fa fa-sort-amount-asc" aria-hidden="true"></i>Sort ascending</span>
            } else return <span><i className="fa fa-sort-amount-asc" aria-hidden="true"></i> Sort descending</span>
        }

        return (
            <div className='OrdersTable overflow-auto'>
                <Spin spinning={loading} tip='Loading...'>
                    <table className='table table-borderless table-striped OrdersTable'>
                        <thead className='thead-light'>
                            <tr>
                                <th className='Template'>Template</th>
                                <th className='MockUp'>Mock up</th>
                                <th>Product type</th>
                                <th>Size</th>
                                <th>File in</th>
                                {
                                    hasSKUTheu ?
                                        <>
                                            <th>Quá hạn</th>
                                            <th>Ngày thiết kế</th>
                                            <th>Ngày thêu</th>
                                            <th>
                                                <div>In QR
                                                    <Tooltip title={sortTitle('printed_qr_at')} onClick={() => handleSort('printed_qr_at')} >
                                                        <i
                                                            className="fa fa-filter cursor-pointer ml-1"
                                                            style={{ color: orderBy === 'printed_qr_at' ? '#0f9d58' : 'unset' }}
                                                        />
                                                    </Tooltip>
                                                </div>
                                                {
                                                    !loading &&
                                                    <span className='text-danger'>{`${statistic_data.sewing_printed_qr} / ${statistic_data.sewing_not_printed_qr}`}</span>
                                                }
                                            </th>
                                        </> : <>
                                            <th>File in bù chi tiết</th>
                                            <th>Quá hạn</th>
                                            <th>Thời gian QCSE</th>
                                            <th>
                                                <div>In QR
                                                    <Tooltip title={sortTitle('printed_qr_at')} onClick={() => handleSort('printed_qr_at')} >
                                                        <i
                                                            className="fa fa-filter cursor-pointer ml-1"
                                                            style={{ color: orderBy === 'printed_qr_at' ? '#0f9d58' : 'unset' }}
                                                        />
                                                    </Tooltip>
                                                </div>
                                                {
                                                    !loading &&
                                                    <span className='text-danger'>{`${statistic_data.sewing_printed_qr} / ${statistic_data.sewing_not_printed_qr}`}</span>
                                                }
                                            </th>
                                        </>
                                }
                                <th>Ngày QC
                                    <Tooltip title={sortTitle('completed_at')} onClick={() => handleSort('completed_at')} >
                                        <i
                                            className="fa fa-filter cursor-pointer ml-1"
                                            style={{ color: orderBy === 'completed_at' ? '#0f9d58' : 'unset' }}
                                        />
                                    </Tooltip>
                                </th>
                                <th className='PartnerOld'>Đối tác cũ</th>
                                <th>Trạng thái</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableContent}
                        </tbody>
                    </table>
                </Spin>
            </div>
        )
    }
}

BatchTable.propTypes = {
    orders: PropTypes.array.isRequired,
    filters: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired
}

export default BatchTable